document.addEventListener('DOMContentLoaded', function () {

  var toggleBtns   = document.querySelectorAll('.sachet-toggle-btn[data-product-handle]');
  var purchaseZone = document.getElementById('nandaka-purchase-zone');
  var dataEl       = document.getElementById('nandaka-product-data');

  if (!toggleBtns.length || !purchaseZone || !dataEl) return;

  var productData;
  try { productData = JSON.parse(dataEl.textContent); }
  catch (e) { console.error('Nandaka: bad product data', e); return; }

  var activeData = productData.current;

  // ── Pre-fetch and cache the OTHER product's zones on page load ───────────
  // This runs silently in the background so the toggle is instant when clicked
  var zoneCache = {};  // { handle: { purchaseZoneHTML, atcZoneHTML } }

  function prefetchProduct(handle) {
    if (zoneCache[handle]) return; // already cached
    fetch('/products/' + handle + '?variant=')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var pz  = doc.getElementById('nandaka-purchase-zone');
        var atc = doc.getElementById('nandaka-atc-zone');
        zoneCache[handle] = {
          purchaseZoneHTML: pz  ? pz.innerHTML  : null,
          atcZoneHTML:      atc ? atc.innerHTML : null
        };
      })
      .catch(function (e) { console.warn('Nandaka prefetch failed:', handle, e); });
  }

  // Pre-fetch the other product immediately (runs in background, no UI impact)
  var otherHandle = productData.other.handle;
  prefetchProduct(otherHandle);

  // Also cache current product so switching back is instant too
  var currentHandle = productData.current.handle;
  zoneCache[currentHandle] = {
    purchaseZoneHTML: purchaseZone.innerHTML,
    atcZoneHTML: (document.getElementById('nandaka-atc-zone') || {}).innerHTML || null
  };

  // ── Helper: set text/html on EVERY element matching an id ────────────────
  // After the PT_472 mobile clone runs, mobile price ids are duplicated
  // (original sticky bar + cloned popup form share the same id). getElementById
  // returns only the first node, so we target all of them by id-as-attribute.
  function setAllById(id, value, asHtml) {
    var nodes = document.querySelectorAll('[id="' + id + '"]');
    nodes.forEach(function (node) {
      if (asHtml) { node.innerHTML = value; }
      else { node.textContent = value; }
    });
  }

  // ── Apply prices, variant ID and selling_plan for a product ─────────────
  function applyProductData(data) {
    var variantInput = document.getElementById('nandaka-variant-input');
    if (variantInput) {
      variantInput.value = data.variantId;
      variantInput.dataset.productid = data.variantId;
    }

    var subWrapperHidden = document.querySelector('.pt_413_subscription_wrapper')
                            ?.classList.contains('pt_413_hidden');
    var isOnetime = subWrapperHidden;

    var form = document.querySelector('.ProductForm');
    var existingSellingPlan = form
      ? form.querySelector('input[name="selling_plan"]')
      : document.querySelector('input[name="selling_plan"]');

    if (isOnetime) {
      if (existingSellingPlan) existingSellingPlan.remove();
    } else {
      if (existingSellingPlan) {
        existingSellingPlan.value = data.sellingPlanId;
      } else {
        var newInput = document.createElement('input');
        newInput.type  = 'hidden';
        newInput.name  = 'selling_plan';
        newInput.value = data.sellingPlanId;
        if (form) form.appendChild(newInput);
      }
    }

    var displayPrice = isOnetime ? data.price : data.subPrice;

    // Update ALL matching price nodes. On mobile, PT_472 clones the form into
    // the popup, so .Quantity__PriceBtn / .Quantity__PriceSub exist more than
    // once. querySelector would only update the first (often not the visible one).
    document.querySelectorAll('.Quantity__PriceBtn').forEach(function (el) {
      el.textContent = displayPrice;
    });
    document.querySelectorAll('.Quantity__PriceSub').forEach(function (el) {
      el.textContent = displayPrice;
    });
    document.querySelectorAll('.ProductOTP-Price').forEach(function (el) {
      el.textContent = data.price;
    });
  }

  function updateStickyBar(data) {
    // Desktop (single instance — safe to keep getElementById)
    var otpPrice   = document.getElementById('sticky-otp-price');
    var subPrice   = document.getElementById('sticky-sub-price');
    var otpCompare = document.getElementById('sticky-otp-compare-price');

    if (otpPrice)   otpPrice.innerHTML   = '<strong>' + data.price + '</strong>';
    if (subPrice)   subPrice.innerHTML   = '<strong>' + data.subPrice + '</strong>';
    if (otpCompare) otpCompare.innerHTML = '<strong>' + data.price + '</strong>';

    // Mobile — update ALL matching nodes so the original sticky bar updates
    // in place even after PT_472 has cloned the form into the popup.
    setAllById('sticky-otp-price-mobile', data.price, false);
    setAllById('sticky-sub-price-mobile', data.subPrice, false);
    setAllById('sticky-otp-compare-price-mobile', data.price, false);
  }

  window.nandakaPriceOverride = function (data) {
    applyProductData(data);
    setTimeout(function () { applyProductData(data); }, 150);
  };

  // ── Sachet toggle click — instant swap from cache ────────────────────────
  toggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {

      if (btn.classList.contains('is-active')) return;

      toggleBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var handle = btn.dataset.productHandle;
      activeData = (handle === productData.current.handle)
                     ? productData.current
                     : productData.other;

      var cached = zoneCache[handle];

      if (cached) {
        // ✅ Instant — no fetch needed, use cached HTML
        if (cached.purchaseZoneHTML !== null) {
          purchaseZone.innerHTML = cached.purchaseZoneHTML;
        }
        var liveAtc = document.getElementById('nandaka-atc-zone');
        if (liveAtc && cached.atcZoneHTML !== null) {
          liveAtc.innerHTML = cached.atcZoneHTML;
        }
        // Correct prices immediately (synchronously) so the stale cached price
        // never paints, then again after pt_413 reinit settles the toggle.
        applyProductData(activeData);
        updateStickyBar(activeData);
        setTimeout(function () {
          if (typeof window.initPt413 === 'function') window.initPt413();
          window.nandakaPriceOverride(activeData);
          updateStickyBar(activeData);
        }, 50);
        setTimeout(function () {
          applyProductData(activeData);
          updateStickyBar(activeData);
        }, 250);
      } else {
        // Cache miss (prefetch not done yet) — fetch normally then cache
        purchaseZone.style.opacity       = '0.4';
        purchaseZone.style.pointerEvents = 'none';
        fetch('/products/' + handle + '?variant=')
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var pz  = doc.getElementById('nandaka-purchase-zone');
            var atc = doc.getElementById('nandaka-atc-zone');
            zoneCache[handle] = {
              purchaseZoneHTML: pz  ? pz.innerHTML  : null,
              atcZoneHTML:      atc ? atc.innerHTML : null
            };
            if (pz) purchaseZone.innerHTML = pz.innerHTML;
            var liveAtc = document.getElementById('nandaka-atc-zone');
            if (liveAtc && atc) liveAtc.innerHTML = atc.innerHTML;
            setTimeout(function () {
              if (typeof window.initPt413 === 'function') window.initPt413();
              window.nandakaPriceOverride(activeData);
              updateStickyBar(activeData);
            }, 50);
          })
          .catch(function (e) { console.error('Nandaka: swap failed', e); })
          .finally(function () {
            purchaseZone.style.opacity       = '';
            purchaseZone.style.pointerEvents = '';
          });
      }

      document.dispatchEvent(new CustomEvent('nandaka:productSwapped', {
        detail: { handle: handle, data: activeData }
      }));
    });
  });

  // ── Sync price + selling_plan when subscribe/onetime toggle changes ───────
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.pt_413_toggle_input_one_time, .pt_413_toggle_input_subscription, .pt_413_onetime_left_lower_cta')) return;
    setTimeout(function () { applyProductData(activeData); updateStickyBar(activeData); }, 50);
  });

});
